export default "__VITE_ASSET__5e95f076__"